import { Box, Grid, Typography, Checkbox, MenuItem, IconButton, Button } from "@mui/material";
import React from "react";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DescriptionIcon from '@mui/icons-material/Description';
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useTMutation } from "../../../../../utils/useTMutation";
import showToast from "../../../../../components/Hot-Toast/showToast";
import { useDispatch, useSelector } from 'react-redux';
import { nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export const fieldSchema = z.object({
    COPY_DOCUMENT: z.boolean().default(false),
    ISSUE_DATE: z.boolean().default(false),
    EXPIRATION_DATE: z.boolean().default(false),
    NOTES: z.boolean().default(false),
});

export default function AddRequiredFields() {

    const { values } = useSelector((state) => state?.multiStep)
    const { selectedTabData } = useSelector((state) => state.profileTabSection);
    console.log("selectedTabData", selectedTabData)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: zodResolver(fieldSchema),
        defaultValues: {
            COPY_DOCUMENT: false,
            ISSUE_DATE: false,
            EXPIRATION_DATE: false,
            NOTES: false,
        },
    });

    const { mutateAsync } = useTMutation("/addHealthDocument", "post", (data) => {
        if (data.STATUS) {
            return data;
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });
    const submitFormData = async (formData) => {
        console.log("formData", formData)
        console.log("values", values)
        const transformedData = {
            COPY_DOCUMENT: formData.COPY_DOCUMENT ? 1 : 0,
            ISSUE_DATE: formData.ISSUE_DATE ? 1 : 0,
            EXPIRATION_DATE: formData.EXPIRATION_DATE ? 1 : 0,
            NOTES: formData.NOTES ? 1 : 0,
        };

        try {
            const response = await mutateAsync({
                transformedData,
                ID: values?.ID,
            });

            if (response.STATUS) {
                dispatch(update({ value: response.OUTPUT }))
                showToast("success", response.MESSAGE, 3000);
                // dispatch(nextStep())
                navigate('/admin/profile-criteria/HealthDocuments');
            } else {
                showToast("error", response.MESSAGE, 3000);
            }

        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    return (
        <>
            {!values.REDIRECT && <Button
                onClick={() => dispatch(previousStep())}
                startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0,marginTop:-1.8 }}
            >
            </Button>}
            <Grid item>
                <Box sx={{ margin: 2 }}>
                    <Typography variant="h1">Select the required fields</Typography>
                </Box>
                <form onSubmit={handleSubmit(submitFormData)}>
                    <Box sx={{ margin: 2 }}>
                        <MenuItem sx={{ background: '#f5f5f5', marginBottom: 1 }}>
                            <IconButton sx={{ background: '#6ebe44', color: 'white', borderRadius: '100px', marginRight: 1 }}>
                                <FileCopyIcon />
                            </IconButton>
                            <Typography>Document copy</Typography>
                            <Checkbox {...register("COPY_DOCUMENT")} 
                            
                             sx={{ marginLeft: 'auto', marginRight: 0, 

                             color: "#6ebe44",
                             '&.Mui-checked': {
                             color: "#6ebe44",
                              },
                              }} />
                        </MenuItem>
                        <MenuItem sx={{ background: '#f5f5f5', marginBottom: 1 }}>
                            <IconButton sx={{ background: '#1ad1ff', color: 'white', borderRadius: '100px', marginRight: 1 }}>
                                <CalendarTodayIcon />
                            </IconButton>
                            <Typography>Issue date</Typography>
                            <Checkbox {...register("ISSUE_DATE")} 
                             sx={{ marginLeft: 'auto', marginRight: 0, 

                                color: "#6ebe44",
                                '&.Mui-checked': {
                                color: "#6ebe44",
                                 },
                                 }}
                             />
                        </MenuItem>
                        <MenuItem sx={{ background: '#f5f5f5', marginBottom: 1 }}>
                            <IconButton sx={{ background: '#ff8000', color: 'white', borderRadius: '100px', marginRight: 1 }}>
                                <CalendarTodayIcon />
                            </IconButton>
                            <Typography>Expiration date</Typography>
                            <Checkbox {...register("EXPIRATION_DATE")} 
                           sx={{ marginLeft: 'auto', marginRight: 0, 

                            color: "#6ebe44",
                            '&.Mui-checked': {
                            color: "#6ebe44",
                             },
                             }}
                            />
                        </MenuItem>
                        <MenuItem sx={{ background: '#f5f5f5', marginBottom: 1 }}>
                            <IconButton sx={{ background: '#ffaa00', color: 'white', borderRadius: '100px', marginRight: 1 }}>
                                <DescriptionIcon />
                            </IconButton>
                            <Typography>Notes</Typography>
                            <Checkbox {...register("NOTES")} error={!!errors.NOTES} helperText={errors.NOTES?.message} 
                          sx={{ marginLeft: 'auto', marginRight: 0, 

                            color: "#6ebe44",
                            '&.Mui-checked': {
                            color: "#6ebe44",
                             },
                             }}
                            />
                        </MenuItem>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 2 }}>
                        <Button 
                         className='gradientAdminThemeColor'
                        // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                        type='submit'>
                            Finish
                        </Button>
                    </Box>
                </form>
            </Grid>
        </>
    );
}
